// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"423":"77621bb8","453":"127be8e2","597":"908805d7","713":"7a6828f1"}[chunkId] + ".chunk.js";
};